const fieldActivations = [
	{
		path: '/agency/field-activations/list',
		name: 'agency-field-activations-list',
		component: () => import('@/views/agency/field-activations/list.vue'),
		meta: { layout: 'content', module: 'MGAG' },
	},
	{
		path: '/agency/field-activations/new',
		name: 'agency-field-activations-new',
		component: () => import('@/views/agency/field-activations/edit.vue'),
		meta: { layout: 'content', module: 'MGAG' },
	},
	{
		path: '/agency/field-activations/edit/:id',
		name: 'agency-field-activations-edit',
		component: () => import('@/views/agency/field-activations/edit.vue'),
		meta: { layout: 'content', module: 'MGAG' },
	},
]

export default fieldActivations
